import React from 'react';
// template components
import Accordion from '@nmx/template/dist/componentLibrary/modules/Accordion';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import MinusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/MinusSignFill';
import PlusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/PlusSignFill';

export default () => (
  <SectionContainer
    id='insurance-faq' // '-section-container' will be appended dynamically
    className='nmx-no-print'
    backgroundVariant='lightA'
    themeType='lightTheme'
    moduleName='faq-module'
    moduleVariation='A'>
    <Row align='center'>
      <Col
        align='center'
        medium={10}
        large={8}>
        <Typography
          component='h2'
          nextElement='typography'>
          Questions about insurance&#63; <WidowBlock>We&#39;ve got answers.</WidowBlock>
        </Typography>
      </Col>
    </Row>
    <Row align='center'>
      <Col
        medium={10}
        large={8}>
        <Accordion
          id='faq-insurance'
          variant='secondary'
          toggleOpenIcon={PlusSignFillIcon}
          toggleCloseIcon={MinusSignFillIcon}
          isFAQ
          items={[
            {
              id: 'insurance-what-is-insurance-coverage-faq',
              title: <>What is <WidowBlock>insurance coverage&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <Typography disableBottomPadding>
                  Insurance helps you and your loved ones recover financially if the unexpected happens, like if you get sick or injured and can&#39;t work or you pass away. <Link variant='primaryDeemphasize' linkUrl='/find-a-financial-advisor/'>Get answers to all your insurance questions, connect with an advisor</Link>.
                </Typography>
              ),
            },
            {
              id: 'insurance-different-types-of-insurance-faq',
              title: <>What are the different types <WidowBlock>of insurance&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <Typography disableBottomPadding>
                  There are several types of insurance that can play an important part in your financial plan: <Link variant='primaryDeemphasize' linkUrl='/life-insurance/'>life insurance</Link>, <Link variant='primaryDeemphasize' linkUrl='/disability-insurance/'>disability insurance</Link>, <Link variant='primaryDeemphasize' linkUrl='/long-term-care-planning/'>long&#45;term care</Link>, and <Link variant='primaryDeemphasize' linkUrl='/annuities/'>annuities</Link>. From having a financial safety net and protecting your income, to covering the cost of care when you&#39;re older and having a guaranteed income stream when you retire, we have industry&#45;leading options to help you reach your goals. <Link variant='primaryDeemphasize' linkUrl='/find-a-financial-advisor/'>Talk with one of our advisors about which types of insurance are best for you</Link>.
                </Typography>
              ),
            },
            {
              id: 'insurance-different-what-types-insurance-faq',
              title: <>How do I know what types of insurance <WidowBlock>I need&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <Typography disableBottomPadding>
                  The best types of insurance for you and your life will depend on your needs and goals. And if you&#39;re not sure what those are, that&#39;s ok. Our advisors can help you figure it out. From <Link variant='primaryDeemphasize' linkUrl='/life-insurance/'>life insurance</Link>, <Link variant='primaryDeemphasize' linkUrl='/disability-insurance/'>disability insurance</Link>, <Link variant='primaryDeemphasize' linkUrl='/long-term-care-planning/'>long&#45;term care</Link>, and <Link variant='primaryDeemphasize' linkUrl='/annuities/'>annuities</Link>, we have everything you need to help make sure you can protect what matters most.
                </Typography>
              ),
            },
            {
              id: 'insurance-different-types-of-life-insurance-faq',
              title: <>What are the different types of <WidowBlock>life insurance&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <Typography disableBottomPadding>
                  There are four kinds of life insurance that can give you the protection you need: <Link variant='primaryDeemphasize' linkUrl='/life-insurance/term-life-insurance/'>term life insurance</Link>, <Link variant='primaryDeemphasize' linkUrl='/life-insurance/whole-life-insurance/'>whole life insurance</Link>, <Link variant='primaryDeemphasize' linkUrl='/life-insurance/universal-life-insurance/'>universal life insurance</Link>, and <Link variant='primaryDeemphasize' linkUrl='/life-insurance/variable-universal-life-insurance-vul/'>variable universal life insurance</Link>. Term life only covers you for a specified amount of time, while whole, universal, and variable universal life insurance all have lifelong coverage. Whole, universal, and variable universal builds cash value over time<sup>4</sup> that you can use for whatever you need, whenever you need it. And whole life can earn dividends that can be taken as cash, used to pay premiums, or buy more coverage. <Link variant='primaryDeemphasize' linkUrl='https://www.northwesternmutual.com/life-and-money/the-different-types-of-life-insurance-explained/'>Get more details on our different types of life insurance</Link>.
                </Typography>
              ),
            },
            {
              id: 'insurance-benefits-of-insurance-faq',
              title: <>What are the benefits <WidowBlock>of insurance&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <Typography disableBottomPadding>
                  Insurance will help make sure that your loved ones will be ok financially if the unexpected happens, like if you pass away, get sick or injured and can&#39;t work, or if a chronic illness or injury prevents you (or a loved one) from living on your own or properly caring for yourself. <Link variant='primaryDeemphasize' linkUrl='/find-a-financial-advisor/'>Talk with one of our advisors about which types of insurance are best for you</Link>.
                </Typography>
              ),
            },
            {
              id: 'insurance-how-to-get-insurance-quotes-faq',
              title: <>How do I get insurance rates and quotes from <WidowBlock>Northwestern Mutual&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <Typography disableBottomPadding>
                  Everyone&#39;s insurance needs are different. Our advisors will show you what kind of insurance is right for you, and how much you&#39;ll need, to keep you and your family financially secure if the unexpected happens. The best way to get an accurate quote, and get answers to your questions, is to <Link variant='primaryDeemphasize' linkUrl='/find-a-financial-advisor/'>connect with one of our advisors</Link>.
                </Typography>
              ),
            },
          ]}
        />
      </Col>
    </Row>
  </SectionContainer>
);
